export default __webpack_public_path__ + "static/media/wikipedia_access.4f0a5161.png";